var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.configuration_tb") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage overflow-hidden" },
          [
            _c(
              "b-container",
              { staticClass: "listPage", attrs: { fluid: "" } },
              [
                _c(
                  "b-row",
                  { staticClass: "text-xl-start mb-3" },
                  [
                    _c(
                      "b-col",
                      { attrs: { xl: "6", lg: "9", md: "12", cols: "12" } },
                      [
                        _c(
                          "b-button-group",
                          { staticClass: "mt-3 mt-sm-0" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "px-4",
                                attrs: {
                                  variant:
                                    _vm.tabName === 1
                                      ? "primary btn-selected"
                                      : "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeTabName(1)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "common.global.corporate_identifier_type"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "px-4",
                                attrs: {
                                  variant:
                                    _vm.tabName === 2
                                      ? "primary btn-selected"
                                      : "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeTabName(2)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("entities_setting_tb.connector_in")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "px-4",
                                attrs: {
                                  variant:
                                    _vm.tabName === 3
                                      ? "primary btn-selected"
                                      : "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeTabName(3)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("entities_setting_tb.connector_out")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.tabName === 1
                  ? _c("CorporateIdentifierType")
                  : _vm.tabName === 2
                  ? _c("WebServiceCredentialDetails", {
                      attrs: { tb: "1", mode: "details" },
                    })
                  : _vm.tabName === 3
                  ? _c("WebServiceConfigurationDetails", {
                      attrs: { tb: "1", mode: "details" },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }